import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';
import SectionsRow from './SectionsRow.jsx';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import ConferenceDropdown from '../../Forms/ConferenceDropdown.jsx';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader, PageToolbar } from '../../componants/Workspace';

const Sections = () => {
  const [sections, setSections] = useState([]);
  const { SetNotification } = useStateContext();
  const [lang, setLang] = useState('English');
  const [loading, setIsLoading] = useState(true);
  const [conferenceId, setConferenceId] = useState();

  const fetchData = async () => {
    try {
      const response = await AxiosClient.get('/sections');
      const _sections = response.data;
      setSections(_sections);
      setIsLoading(false);
    } catch (error) {
      SetNotification('Error fetching data', 'danger');
    }
  };

  useEffect(() => {
    if (conferenceId !== undefined) {
      fetchData();
    }
  }, [conferenceId]);

  const handleDeleteArt = async (id) => {
    try {
      await AxiosClient.delete(`/sections/${id}`);
      fetchData();
      SetNotification('An article has been deleted', 'success');
    } catch (error) {
      console.error(error);
      SetNotification('Error while deleting the section', 'danger');
    }
  };

  // Filter sections by both conferenceId and lang
  const filteredSections = sections.filter((section) => {
    return (
      section.conference_id === conferenceId && section.language === lang
    );
  });

  return (
    <>
      <PageHeader
        title="Sections"
        description="Organize the content shown to attendees."
        actions={conferenceId && (
          <>
            <Link className="btn btn-primary" to="./Add">
              <i className="material-icons" aria-hidden="true">add</i>
              Add section
            </Link>
            <Link className="btn btn-outline-secondary" to={`./sort/${conferenceId}/${lang}`}>
              <i className="material-icons" aria-hidden="true">sort</i>
              Manage order
            </Link>
          </>
        )}
      />

      <PageToolbar
        filters={(
          <>
            <ConferenceDropdown conferenceId={conferenceId} setConferenceId={setConferenceId} />
            <div className="workspace-filter-group">
              <span className="workspace-filter-group__label">Language</span>
              <div className="workspace-segmented" role="group" aria-label="Filter sections by language">
                {['English', 'Arabic'].map((language) => (
                  <button
                    key={language}
                    type="button"
                    className={`btn ${lang === language ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => setLang(language)}
                    aria-pressed={lang === language}
                  >
                    {language}
                  </button>
                ))}
              </div>
            </div>
          </>
        )}
      />

      {!conferenceId ? (
        <div className="workspace-empty">Select a conference to view its sections.</div>
      ) : loading ? (
        <div className="workspace-loading"><Loader label="Loading sections..." /></div>
      ) : (
        <DataTable className="table-fixed">
          <thead>
            <tr>
              <th>Title</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredSections.length > 0 ? filteredSections.map((sectionItem) => (
              <SectionsRow
                key={sectionItem.id}
                title={sectionItem.title}
                description={sectionItem.description}
                id={sectionItem.id}
                onDelete={handleDeleteArt}
              />
            )) : (
              <tr>
                <td colSpan="3" className="workspace-empty">No sections match this conference and language.</td>
              </tr>
            )}
          </tbody>
        </DataTable>
      )}
    </>
  );
};

export default Sections;
